export enum Accessor {
  Index = 'index',
  Title = 'title',
  TruckCode = 'truckCodeId',
  Qty = 'qty',
  PhoneNumber = 'phoneNumber',
  Email = 'email',
  Actions = 'actions',
}
